module.exports = __webpack_public_path__ + "img/breathing-exercises.42412ae3.png";